export default __webpack_public_path__ + "static/assets/med_x_spoon.9e515d6d.png";